import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    eventDetails: {
        title: null,
        start: null,
        end: null,
    },
};

// Async thunk to set event details
export const setEventDetails = createAsyncThunk(
    'eventDetails/setEventDetails',
    async (eventDetails) => {
        return eventDetails;
    }
);

export const eventDetailsSlice = createSlice({
    name: 'eventDetails',
    initialState,
    reducers: {
        reset: (state) => {
            state.eventDetails = { title: null, start: null, end: null };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setEventDetails.fulfilled, (state, action) => {
            state.eventDetails = action.payload;
        });
    },
});

export const { reset } = eventDetailsSlice.actions;
export default eventDetailsSlice.reducer;
